import * as React from "react";
import {
  TextField,
  BooleanField,
  ImageField,
  Show,
  usePermissions,
  useRecordContext,
  Title,
  NumberField,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";
import PolygonMap from "./PolygonMap/PolygonMap";

const RegionTitle = () => {
  const record = useRecordContext();
  return <Title title={`Región "${record?.name}"`} />;
};

const PolygonShow = () => {
  const record = useRecordContext();
  const path = record?.points?.coordinates
    ? record.points.coordinates[0].map(([lng, lat]) => ({
        lat,
        lng,
      }))
    : [];

  const centroid = record?.centroid
    ? { lng: record?.centroid[0], lat: record?.centroid[1] }
    : undefined;

  return <PolygonMap initialPath={path} centroid={centroid} editable={false} />;
};

const RegionShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<RegionTitle />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <TextField source="name" label="Nombre" />
        <ImageField source="image" label="Imagen" />
        <PolygonShow />
        <TextField source="country" label="País" />
        <NumberField source="order" label="Orden" />
        <BooleanField source="hasDiscounts" label="Descuentos" />
        <BooleanField source="visible" label="Visible" />
        <BooleanField source="active" label="Activo" />
      </SimpleShowLayout>
    </Show>
  );
};

export default RegionShow;
